import React from 'react'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { API } from 'aws-amplify';
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip';
import { FaInfoCircle } from 'react-icons/fa';

import DropDown from "../FormComponents/DropDown"
import DOMAIN_CONFIG from './config/ModelingDomain.json'
import ModelingDomain from './FormComponents/ModelingDomain'
import JobIds from '../FormComponents/JobIds'
import FileUpload from '../FormComponents/FileUpload'
import FileSelect from '../FormComponents/FileSelect'
import TextOption from '../FormComponents/TextOption'
import NumberInput from '../FormComponents/NumberInput'

import { styles, translateRequestBody, validateRequestBody } from './util'

const d = new Date()

class WRFForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requestId: null,
            model: 'WRF',
            previousProjSucc: '',
            modelDescription: ``,
            wrfV: 'v4.5',
            runOption: 'setup',
            start_date: '2025-08-01',
            end_date: '2025-08-06',
            physics_option: 'conus',
            boundary_met: 'era5',
            max_dom: null,
            parent_id: '',
            parent_grid_ratio: '',
            i_parent_start: '',
            j_parent_start: '',
            e_we: '',
            e_sn: '',
            dx: null,
            dy: null,
            map_proj: "lambert",
            ref_lat: '',
            ref_lon: '',
            truelat1: '',
            truelat2: '',
            stand_lon: '',
            computeOption: "12:62000"
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLoadProjChange = this.handleLoadProjChange.bind(this);
        this.readDomainFile = this.readDomainFile.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.classes = this.props.classes;

        // Avoid setting the state after the component was unmounted
        // https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.type === 'radio' ? target.attributes.radioname.value : target.name;

        this.setState({
            [name]: value
        });
        
        if ( name === "start_date"){
            this.setState({
                ["end_date"]: value
            });
        }
    }

    handleLoadProjChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        console.log(value,name)
        this.setState({
            [name]: value
        });

        this.api_post_loadproj(value,name)
    }

    readDomainFile(event) {
        if (event.target.files.length > 0) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const text = e.target.result;
                var lines = text.split(/\r\n|\n/);
                for (var line = 0; line < lines.length - 1; line++) {
                    let currentLine = lines[line].split('=')
                    let lineName = currentLine[0].trim();
                    if (currentLine[1]) {
                        let lineValue = currentLine[1].trim();
                        let domainValues = DOMAIN_CONFIG.modeling_domain.values;
                        for (var index = 0; index < domainValues.length; index++) {
                            if (lineName == domainValues[index].value) {
                                let convertedValue = domainValues[index].type == "number" ? parseInt(lineValue) : lineValue.toString();
                                console.log('setting state of ' + lineName + ' to ' + convertedValue);
                                this.setState({
                                    [lineName]: convertedValue
                                });
                            }
                        }
                    }
                }
            }
            reader.readAsText(event.target.files[0]);
        }
    }

    api_post_loadproj(value,name) {
        let request = {
            'projID' : value,
            'type' : name
        }
        let options = {
            body: request,
            headers: {},
            response: true
        }
        console.log(request['type'],request['projID'])

        if (request['type'] === 'previousProjSucc'){
            API.post("AQcast", "/request/loadProj/", options)
                    .then(response => {
                        this.setState(response.data)
                        console.log(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                    })
                }
    }    

    api_post_wrf(request) {
        let options = {
            body: request,
            headers: {},
            response: true
        }

        this.setState({requestId: 'Loading'});

        API.post("AQcast", "/request/aermod/", options)
            .then(response => {
                this._isMounted && this.setState({requestId: response.data.requestId});
            })
            .catch(error => {
                this._isMounted && this.setState({validationError: 'error.errorMessage'});
                console.log(error)
            })
    }

    handleSubmit(event) {
        event.preventDefault()
        // Check if the user has left any necessary fields blank
        const errorString = validateRequestBody(this.state)
        if (errorString) {
            this.setState({
                validationError: errorString
            })
            // alert(errorString);
        } else {    // Submit normally
            this.setState({
                validationError: errorString
            })

            const requestBody = translateRequestBody(this.state)
            this._isMounted && this.api_post_wrf(requestBody)
        }
        event.preventDefault();
    }

    displayForm(){
        if (this.state.runOption === "setup") {
            return (
                <span>
                <DropDown
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='WRF & WPS Version:'
                    name='wrfV'
                    value={this.state.wrfV}
                    dropdownOptions={
                        [{
                            value: "v4.2",
                            label: "v4.2"
                        },{
                            value: "v4.3",
                            label: "v4.3"
                        },{
                            value: "v4.5",
                            label: "v4.5"
                        }]
                    }
                    tooltip={<div key='physics_option0'>Newer versions COMING SOON</div>}
                />
                <br/>    
                <div>
                    <label>
                        Start Date:
                        <input 
                            type="date"
                            id="start"
                            name="start_date"
                            value={this.state.start_date}
                            onChange={this.handleInputChange}
                            placeholder="2025-07-18"
                        />
                    </label>
                </div>
                <br />
                <div>
                    <label>
                        End Date:
                        <input 
                            type="date"
                            id="start"
                            name="end_date"
                            value={this.state.end_date}
                            onChange={this.handleInputChange}
                            placeholder="2025-08-18"
                        />
                    </label>
                </div>
                <br />                                
                <DropDown
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Physics Option Set:'
                    name='physics_option'
                    value={this.state.physics_option}
                    dropdownOptions={
                        [{
                            value: "conus",
                            label: "CONUS"
                        },{
                            value: "tropical",
                            label: "Tropical"
                        }]
                    }
                    tooltip={[<div key='physics_option0'>CONUS: Default WRF parameters for locations in the continental US.</div>,
                        <div key='physics_option1'>Topical: Default WRF parameters for locations in the tropics.</div>
                    ]}
                />

                <DropDown
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Boundary Meteorology:'
                    name='boundary_met'
                    value={this.state.boundary_met}
                    dropdownOptions={
                        [{
                            value: "era5",
                            label: "ERA5"
                        }]
                    }
                    tooltip={<div key='physics_option0'>Other options COMING SOON</div>}
                />
                <DropDown
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Computation Settings:'
                    name='computeOption'
                    value={this.state.computeOption}
                    dropdownOptions={
                        [{
                            value: "12:62000",
                            label: "12 vCPU, 62 GB RAM"
                        },
                        {
                            value: "16:126000",
                            label: "16 vCPU, 126 GB RAM"
                        },
                        {
                            value: "24:126000",
                            label: "24 vCPU, 126 GB RAM"
                        },
                        {
                            value: "24:250000",
                            label: "24 vCPU, 250 GB RAM"
                        },
                        {
                            value: "48:189000",
                            label: "48 vCPU, 189 GB RAM"
                        },
                        {
                            value: "64:126000",
                            label: "64 vCPU, 126 GB RAM"
                        },
                        {
                            value: "72:189000",
                            label: "72 vCPU, 189 GB RAM"
                        },
                        {
                            value: "96:189000",
                            label: "96 vCPU, 189 GB RAM"
                        }
                    ]
                    }
                    tooltip={[<div key='option0'>Choose the compute and memory bundle to run your domain with.</div>]}
                />                
                <br></br><br></br>
                <div> 
                    Use this <a href="https://jiririchter.github.io/WRFDomainWizard/" target = "_blank">link</a> to create your domain. Do the following:
                </div> 
                <div> <br></br>
                    1. In the 'Domains' section, click 'New'<br></br>
                    2. Select area of interest on the map<br></br>
                    3. At the bottom of the 'Domains' section, click 'Save'<br></br>
                    4. A popup with the content of the 'namelist.wps' will appear<br></br>
                    5. At the bottom of the popup, click 'Download'<br></br>
                </div><br></br>
                <ModelingDomain
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    readDomainFile={this.readDomainFile}
                    domain={this.state}
                    domain_config={DOMAIN_CONFIG}
                    title="Modeling Domain:"
                    tooltip="Upload or input the required parameters from your namelist.wps file."
                />                    

                </span>
            )

        } else if (this.state.runOption ==='bulkrun') { 
            return (
                <span>
                <JobIds
                    classes={this.classes}
                    handleInputChange={this.handleLoadProjChange}
                    value={this.state.previousProjSucc}
                    title='Choose a Successful WRF Setup Run:'
                    name='previousProjSucc'
                    model='WRF'
                />
                <div><h3>Chosen options:</h3>
                Compute Option (cpu:ram) = {this.state.computeOption} 
                <br></br>
                Start Date = {this.state.start_date}
                <br></br>
                End Date = {this.state.end_date}
                <h2> </h2>
                </div>
                </span>
            )             
        }    
    }

    displayJobResultLink(){
        if (this.state.requestId === null){
            return null
        } else if (this.state.requestId === "need_tokens") {
            return (
                <b style={{color: 'red'}}>
                    Meteorological Allowances = 0  (purchase more or use met from previous run.)
                </b>
            )
        } else if (this.state.requestId ==='Error') {
            return (
                <b style={{color: 'red'}}>
                    Error submitting job
                </b>
            )
        } else if (this.state.requestId ==='Loading') {
            return (
                <span >
                    Submitting Job...
                </span>
            )
        } else {
            return (
                <span>
                    <Button
                        className={classNames(this.props.margin)}
                        variant="text"
                        color="default"
                        component={Link}
                        target="_blank"
                        to={{
                            pathname: '/WRF/Results',
                            search: '?requestId=' + this.state.requestId
                        }}
                    > Click here to view results of job: {this.state.requestId} </Button>
                    <div><i>Your run has been submitted.  You will receive an email when the project has finished.</i></div>
                    <div><i>In the meantime, you may navigate to other pages or logout of AQcast.</i></div>
                </span>
            )
        }

    }

    render() {

        return (
            <form onSubmit={this.handleSubmit} >
                <DropDown
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Run Option:'
                    name='runOption'
                    value={this.state.runOption}
                    dropdownOptions={
                        [{
                            value: "setup",
                            label: "Setup"
                        },
                        {
                            value: "bulkrun",
                            label: "Bulk Runs"
                        }
                    ]
                    }
                    tooltip={[<div key='runOption0'><b>Setup:</b> Setup Domain and run 1 day to check selections</div>,
                              <div key='runOption1'><b>Bulk Runs:</b> Using a successful setup run, complete the runs in the timerange. Note: you'll need 1 met token per day.</div>
                    ]}
                />
                <TextOption
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Project Short Description:'
                    name='modelDescription'
                    maxLength='20'
                    placeholder="Ex: CONUS 12km"
                    width='250px'
                    value={this.state.modelDescription}
                    tooltip={[<div key='modelDescription'>A short description for this model (reference only). Max Length: 48 characters, (Spaces, hyphens, and underscores only.)</div>]}
                />


                <div>{this.displayForm()}</div>
                <Button
                    className={classNames(this.classes.margin, this.classes.textField)}
                    type="submit"
                    variant="contained"
                    color="primary"> Submit
                </Button>
                {this.displayJobResultLink()}
                <b style={{color:'red'}}>{this.state.validationError}</b>

            </form>
        )}
}


WRFForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles())(WRFForm);
